import React, { useEffect } from 'react';

// Components
import InstrumentComparisonLabels from '@/views/components/compliance-comparison/InstrumentComparisonLabels';
import InstrumentComparisonCard from '@/views/components/compliance-comparison/InstrumentComparisonCard';

// Hooks
import { getInstrumentComparisonConfigs } from '@/views/components/compliance-comparison/utils/instrument-comparison-config';

// Types
import { FieldConfig } from '@/views/components/compliance-comparison/InstrumentComparisonCard';
import { ReduxState } from '@/redux/modules/types';
import Fund from '@/types/fund';
import Stock from '@/types/stock';

// Utils
import { HOLDING_TYPES } from '@/utils/portfolios';
import { useSelector } from 'react-redux';

type InstrumentType = Fund | Stock;

interface InstrumentComparisonTableProps<T extends InstrumentType> {
  complianceAlternatives: T[];
  instrumentType: T extends Fund ? HOLDING_TYPES.FUND : HOLDING_TYPES.STOCK;
  onSelect: (item: T) => void;
  clearComplianceAlternatives: () => void;
}

function InstrumentComparisonTable<T extends InstrumentType>(props: InstrumentComparisonTableProps<T>) {
  const user = useSelector((state: ReduxState) => state.auth.user);
  const { complianceAlternatives, instrumentType, onSelect, clearComplianceAlternatives } = props;
  const { getConfigs, notificationSuccess } = getInstrumentComparisonConfigs(user);

  const { labelConfigs, fieldConfigs, selectLabel } = getConfigs(instrumentType);

  useEffect(() => {
    if (complianceAlternatives?.length) {
      notificationSuccess(complianceAlternatives, instrumentType);
    }
    return () => clearComplianceAlternatives();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="instrument-comparison-table d-flex">
      <InstrumentComparisonLabels labels={labelConfigs} />
      <div className="instrument-comparison-cards">
        {complianceAlternatives.map(item => (
          <InstrumentComparisonCard<T> key={item._id} item={item} fields={fieldConfigs as FieldConfig<T>[]} onSelect={onSelect} selectLabel={selectLabel} />
        ))}
      </div>
    </div>
  );
}

export default InstrumentComparisonTable;
